import { onMounted, onBeforeUnmount, watch, Ref, ComponentPublicInstance } from 'vue';

export function useInertHidden(targetRef: Ref<HTMLElement | ComponentPublicInstance | null>) {
  let observer: MutationObserver | null = null;

  const getElement = (target: HTMLElement | ComponentPublicInstance) => {
    return '$el' in target ? target.$el : target;
  };

  const applyInertToHiddenElements = () => {
    const target = targetRef.value;
    if (!target) return;
    const element = getElement(target);
    if (!(element instanceof HTMLElement)) return;
    const hiddenElements = element.querySelectorAll('[aria-hidden="true"]');
    hiddenElements.forEach((el) => {
      el.setAttribute('inert', '');
    });
    // Also remove inert from visible elements if they were previously hidden
    const previouslyInert = element.querySelectorAll('[inert]');
    previouslyInert.forEach((el) => {
      if (el.getAttribute('aria-hidden') !== 'true') {
        el.removeAttribute('inert');
      }
    });
  };

  onMounted(() => {
    watch(
      targetRef,
      (target) => {
        if (!target) return;
        applyInertToHiddenElements();

        observer = new MutationObserver(() => {
          applyInertToHiddenElements();
        });
        const element = getElement(target);
        if (!(element instanceof HTMLElement)) return;
        observer.observe(element, {
          childList: true,
          subtree: true,
        });
      },
      { immediate: true },
    );
  });

  onBeforeUnmount(() => {
    observer?.disconnect();
    observer = null;
  });
}
